import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LinkService {
  regionalizedRoute: string = '';

  setRegionalizedRoute(route: string): void {
    this.regionalizedRoute = route;
  }

  getRouterLink(route: string): string {
    return `${this.regionalizedRoute}/${route}`;
  }
}
